import React from 'react';
import { formatEUR } from '../../../constants/tool.fn';
import i18n from '../../../i18n';
import SalesCompareDialog, { SalesCompareDialogItem } from './sales-compare-dialog';
import { ExtraAnalysisRow } from './state/dish-data-shared.types';

/** 组件属性。 */
interface ExtraAnalysisCompareDialogProps {
    /** 弹窗开关。 */
    open: boolean;
    /** 关闭弹窗。 */
    onClose: () => void;
    /** 当前选中的额外费用行。 */
    rows: ExtraAnalysisRow[];
}

/**
 * 获取额外费用行的展示名称。
 * @param row - 额外费用行
 * @returns 展示名称
 */
function getExtraRowName(row: ExtraAnalysisRow) {
    return row.name || row.menu_item_name || '–';
}

/**
 * 额外费用数据对比弹窗。
 */
function ExtraAnalysisCompareDialog({ open, onClose, rows }: ExtraAnalysisCompareDialogProps) {
    /** 对比项映射。 */
    const compareItems: SalesCompareDialogItem[] = rows.map((row) => ({
        key: row.rowKey,
        label: getExtraRowName(row),
        amount: formatEUR(Number(row.sum_price ?? 0)),
        total_amount: row.sum_price ?? 0,
        total_quantity: Number(row.sum_quantity ?? 0),
        quantity: String(Number(row.sum_quantity ?? 0)),
        ratio: Number(row.count_percentage ?? 0),
        curve: (row.daily_curve ?? []).map((point) => ({
            x: point.x,
            y: Number(point.quantity ?? 0),
        })),
    }));

    return (
        <SalesCompareDialog
            open={open}
            onClose={onClose}
            items={compareItems}
            title={i18n.t('business_analysis_page_text_data_compare')}
            lineChartTitle={i18n.t('business_analysis_page_additional_cost_sales_analysis')}
        />
    );
}

export default ExtraAnalysisCompareDialog;
